import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
// import useResponsive from '../../hooks/useResponsive';
// components
// import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import AllPagesHeader from './header';
import AllPagesNavbar from './nav/AllPagesNavbar';
import { NAV } from '../../config-global';
// ----------------------------------------------------------------------

export default function AllPagesLayout() {
    //   const { themeLayout } = useSettingsContext();
    //   const isDesktop = useResponsive('up', 'lg');

    const [open, setOpen] = useState(true);
    const [navWidth, setNavWidth] = useState(NAV.W_DASHBOARD);

    const handleOpen = () => {
        setOpen(true);
        setNavWidth(NAV.W_DASHBOARD);
    };

    const handleClose = () => {
        setOpen(false);
        setNavWidth(0);
    };

    //   const renderNavVertical = <JJMINavbar openNav={open} onCloseNav={handleClose} />;

    return (
        <>
            <AllPagesHeader openNav={open} onOpenNav={handleOpen} navWidth={navWidth} />

            <Box
                sx={{
                    display: { lg: 'flex' },
                    minHeight: { lg: 1 },
                }}
            >
                <AllPagesNavbar openNav={open} onOpenNav={handleOpen} onCloseNav={handleClose} navWidth={navWidth} />

                <Main>
                    <Outlet />
                </Main>
            </Box>
        </>
    );
}
